/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"
import axios from "@/axios.js"
// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////
// *From Auth - Data will be received from auth provider
const userDefaults = {
  uid         : 0,          // From Auth
  displayName : "John Doe", // From Auth
  about       : "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
  photoURL    : require("@/assets/images/portrait/small/avatar-s-11.jpg"), // From Auth
  status      : "online",
  userRole    : "superAdmin",
  photoName   : "",
  level       : 1
}

const getUserStorage = () =>{
  if(localStorage.getItem("userInfo")){
    return JSON.parse(localStorage.getItem("userInfo"))
  } else if (sessionStorage.getItem("userInfo")){
    return JSON.parse(sessionStorage.getItem("userInfo"))
  } else {
    return {}
  }
}

const userInfoLocalStorage = getUserStorage()
// const userInfoLocalStorage = JSON.parse(localStorage.getItem("userInfo")) || {}

// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
const getUserInfo = () => {
  let userInfo = {}

  // Update property in user
  Object.keys(userDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    if (key == 'photoURL'){
      if (userInfoLocalStorage[key] && !userInfoLocalStorage[key].includes('/img')){
        userInfo[key] =  require("@/assets/images/portrait/small/" + userInfoLocalStorage[key])
        userInfo['photo_name'] = userInfoLocalStorage[key]
      } else {
        userInfo[key] = userInfoLocalStorage[key] ?  userInfoLocalStorage[key] : userDefaults[key]
        userInfo['photo_name'] = userInfoLocalStorage[key]
      }
    } else {
      userInfo[key] = userInfoLocalStorage[key] ?  userInfoLocalStorage[key] : userDefaults[key]
    }
  })
  // Include properties from localStorage
  Object.keys(userInfoLocalStorage).forEach((key) => {
    if(userInfo[key] == undefined && userInfoLocalStorage[key] != null) userInfo[key] = userInfoLocalStorage[key]
  })

  return userInfo
}


// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  var mq = function(query) {
      return window.matchMedia(query).matches;
  }

  if (('ontouchstart' in window) || window.DocumentTouch) {
      return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
}


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
    AppActiveUser           : getUserInfo(),
    isMobile                : false,
    bodyOverlay             : false,
    isVerticalNavMenuActive : true,
    is_touch_device         : is_touch_device(),
    mainLayoutType          : themeConfig.mainLayoutType || "vertical",
    navbarSearchAndPinList  : 'navbarSearchAndPinList',
    reduceButton            : themeConfig.sidebarCollapsed,
    verticalNavMenuWidth    : "default",
    verticalNavMenuItemsMin : false,
    scrollY                 : 0,
    // starredPages            : navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
    theme                   : themeConfig.theme || "light",
    themePrimaryColor       : colors.primary,
    masterServer            : "7770",
    workspaceServer         : "7771",
    projectServer           : "7772",
    uploadFileMaxSize       : 15360000, // 15MB
    hamburger: false,
    adminUserList: ['mesen@naver.com', 'sol03260@naver.com', 'filleduadm@daum.net', 'heroing1004@naver.com', 'tkdals5531@naver.com'],
    postList: [
      {
          'title': '안양대 대학일자리플러스센터ㆍ(주)필드유, 정보통신 및 소프트웨어 분야 인재 양성',
          'date': '22.11.29',
          'detail': '안양대학교(총장 박노준)는 안양대 대학일자리플러스센터와 온라인 학업 플랫폼 회사인 (주)필드유(대표 양지영)가 정보통신 및 소프트웨어 분야 인재 양성을 위해 업무 협약을 체결했다고..'
      },{
          'title': '안양산업진흥원, 엑셀러레이팅 선정 기업 대상 IR피칭 컨설팅',
          'date': '19.09.27',
          'detail': '안양산업진흥원은 지난 23일 청년창업기업 액셀러레이팅 지원 사업에 선정된 청년기업을 대상으로 IR피칭 컨성팅을 진행했다고 27일 밝혔다. 이번 행사는 다래전략사업화센터가 운영하는... '
      },{
          'title': '안양창조산업진흥원, 청년기업 데모데이 개최',
          'date': '19.12.22',
          'detail': "안양창조산업진흥원은 지난 19일 ‘청년기업 사업화 컨설팅 지원사업 데모데이'를 개최했다. 안양창업지원센터 3층에서 열린 이날 행사는 ‘청년기업 사업화 컨설팅 지원사업'의 최종 마무리하려고 했지만 여기까지 이어지는 긴글을 과연 읽을 사람이 있을까 싶어 테스트겸 최대한 문장의 길이를 늘려서 말하는 방법을 생각하며 여기에 적어본다"
      },
    ],
    // fromUrl                 : "",
    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    baseURL : axios.defaults.baseURL,
    windowWidth: null,
    superAdmin: 'admin@filledyou.com',
    snackBar: {},
}

export default state
